// @ts-nocheck
import React from "react";
import { Typography, Tooltip, Box, useMediaQuery } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import { isTimeTBD } from "../../../../appCalcutions";

export const Option = ({ position, getTimeString }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      <Box
        // {...props}
        sx={{
          width: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "8px",
          boxSizing: "border-box",
          backgroundColor: "transparent",
          border: `0.5px solid ${getCssVariableHandler({
            variableName: "--font-rgb",
          })}`,
          borderRadius: `0.5rem`,
          overflow: "visible",
          cursor: "pointer",
        }}
        className={`autocomplete-option`}
        data-option={"contractor-search-option"}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "1rem",
            padding: "0 1rem",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: isSmallScreen ? "flex-start" : "center",
              gap: "1rem",
            }}
          >
            <Box
              sx={{
                flexGrow: "1",
                // width: "calc(100% - 60px)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.85rem",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: isSmallScreen
                      ? "space-between"
                      : "flex-start",
                    gap: "0.5rem",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="span"
                    sx={{
                      color: "white",
                      margin: "0",
                    }}
                  >
                    {position?.positionName}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "0.80rem",
                  fontWeight: "200",
                }}
              >
                <Typography variant="span">
                  <span style={{ fontWeight: "500" }}>Start Date:</span>{" "}
                  {`${dayjs(position?.startDate)}`}
                </Typography>

                {isTimeTBD(position?.timeIn) || isTimeTBD(position?.timeOut) ? (
                  <Typography variant="span">
                    <span style={{ fontWeight: "500" }}>Time:</span>{" "}
                    {`TBD ${position?.numberOfHours} ${position?.numberOfHours > 1 ? "hourss" : "hour"}`}
                  </Typography>
                ) : (
                  <React.Fragment>
                    <Typography variant="span">
                      <span style={{ fontWeight: "500" }}>Time In:</span>{" "}
                      {getTimeString(position?.timeIn)}
                    </Typography>
                    <Typography variant="span">
                      <span style={{ fontWeight: "500" }}>Time Out:</span>{" "}
                      {getTimeString(position?.timeOut)}
                    </Typography>
                  </React.Fragment>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default function PositionList({
  positions,
  getTimeString,
  showAtLeast = 1,
}) {
  const [isHovered, setIsHovered] = useState(false);

  if (!positions || positions?.length === 0) return null;

  const displayedPosition = showAtLeast ? positions[0] : null;
  const remainingCount = positions?.length - 1;

  const positionText = (position) =>
    `${position?.positionName} - ${dayjs(position?.startDate).format("LL")} - ${
      isTimeTBD(position?.timeIn)
        ? `TBD (${position?.numberOfHours}) hour${position?.numberOfHours > 1 ? "s" : ""}`
        : `${getTimeString(position?.timeIn)} - ${getTimeString(position?.timeOut)}`
    }`;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      {showAtLeast ? (
        <Typography>{positionText(displayedPosition)}</Typography>
      ) : null}
      <Tooltip
        title={
          <Box
            sx={{
              maxHeight: "500px",
              overflowY: "auto",
              display: "inline",
              flexDirection: "column",
              gap: "0.25rem",
              backgroundColor: "#121524",
            }}
          >
            {positions?.slice(showAtLeast == 0 ? 0 : 1)?.map((pos, idx) => (
              <Option position={pos} getTimeString={getTimeString} key={idx} />
            ))}
          </Box>
        }
        placement="bottom"
        arrow
      >
        <Typography
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          sx={{ cursor: "pointer", textWrap: "nowrap" }}
        >
          {remainingCount > 0
            ? `${showAtLeast ? ", " : ""} ${showAtLeast == 0 ? positions?.length : remainingCount} ${showAtLeast == 0 ? "" : "more"} position${remainingCount > 1 ? "s" : ""}`
            : null}
        </Typography>
      </Tooltip>
    </Box>
  );
}

PositionList.propTypes = {
  positions: PropTypes.array,
  getTimeString: PropTypes.func,
  showAtLeast: PropTypes.number,
};
Option.propTypes = {
  position: PropTypes.array,
  getTimeString: PropTypes.func,
};